import { render, staticRenderFns } from "./ResubmitPartner.vue?vue&type=template&id=0bb352fe"
import script from "./ResubmitPartner.vue?vue&type=script&lang=js"
export * from "./ResubmitPartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports